import { render, staticRenderFns } from "./CorporateClintSetup.vue?vue&type=template&id=0a4db2d1&scoped=true"
import script from "./CorporateClintSetup.vue?vue&type=script&lang=js"
export * from "./CorporateClintSetup.vue?vue&type=script&lang=js"
import style0 from "./CorporateClintSetup.vue?vue&type=style&index=0&id=0a4db2d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4db2d1",
  null
  
)

export default component.exports